import FetchService from "./Shared/FetchService";
export default class FinanceService {
    static getFinances(affiliationId) {
        return FetchService.get("/aviso/advisor/getFinances", { affiliationId });
    }
    static getAllFundingSources() {
        return FetchService.get("/aviso/fundingSource/listAsJson");
    }
    static canIViewFundingSources() {
        return FetchService.getSingleResponse("/aviso/fundingSource/canIViewFundingSources");
    }
    static canIViewBalanceDue() {
        return FetchService.getSingleResponse("/aviso/advisor/canIViewBalanceDue");
    }
    static setFundingSourcesForPerson(affiliationId, fundingSourceIds) {
        return FetchService.postSingleResponse("/aviso/advisor/setFundingSourcesForPerson", {
            affiliationId,
            fundingSourceIds,
        });
    }
}
